import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAcademy } from '../AcademyContext';
import Breadcrumb from '../components/Breadcrumb';
import CourseCard from '../components/CourseCard';
import ValueVault from '../components/ValueVault';

const TopicPage = () => {
  const { topicId } = useParams();
  const { getTopic } = useAcademy();
  const topic = getTopic(topicId);

  if (!topic) return <Navigate to="/academy" replace />;

  return (
    <main className="ac-page">
      <Breadcrumb
        items={[
          { label: 'All Topics', to: '/academy' },
          { label: topic.title },
        ]}
      />

      <div className="ac-section-head">
        <h2 className="ac-section-title">Courses</h2>
        <span className="ac-section-meta">
          {topic.courses.length} {topic.courses.length === 1 ? 'course' : 'courses'}
        </span>
      </div>

      <div className="ac-grid ac-grid-2">
        {topic.courses.map((course) => (
          <CourseCard key={course.id} topicId={topic.id} course={course} accent={topic.accent} />
        ))}
      </div>

      <div className="ac-section">
        <ValueVault items={topic.valueVault || []} />
      </div>
    </main>
  );
};

export default TopicPage;
